import React, {Component} from "react";
import Button from "react-toolbox/lib/button/Button";
import {Link} from "react-router-dom";
import PropTypes from "prop-types";
import SegmentedProgress from "./SegmentedProgress";
import ValidatedForm, {FormValidator, UtilDataValidators} from "./form/ValidatedForm";
import { InputAdapter } from "./form/FormAdapters.js";
import { Errors } from "../Strings.js";
import {SignupChallenge, ConfirmPasswordValidator} from "./Signup";
import "./Signup.css";

class ResetPassword extends Component {

	constructor(props) {
		super(props);

		this.nextStep = this.nextStep.bind(this);
		this.lookupAccount = this.lookupAccount.bind(this);
		this.verifyAccount = this.verifyAccount.bind(this);
		this.changePassword = this.changePassword.bind(this);

		this.contactId = null;
		this.userId = props.userId;

		this.state = {
			processStep: ResetPasswordStep.userId,
			challenge: {},
			processStatus: ProcessStatus.inProgress,
			lastStepStatus: ProcessStatus.succeeded,
			lastStepResultMessage: null,
			lastStepFieldValidationMessages: null
		};
	}

	lookupAccount(userNameFormData) {
		this.userId = userNameFormData.username;
		let requestData = JSON.stringify(userNameFormData);
		let request = {
			method: "post",
			url: "signup/userChallenge",
			data: requestData
		};
		this.props.server(request).then((response) => {
			let challenge = response.data;
			//If the info sent doesn't match, the server does not
			//return an error, it just returns null for the question.
			if (challenge.question) {
				this.contactId = challenge.contactId;
				this.nextStep({
					challenge: challenge, 
					lastStepStatus: ProcessStatus.succeeded, 
					lastStepResultMessage: null
				});
			} else {
				let msg = "The User ID you entered cannot be found.";
				this.setState({
					lastStepStatus: ProcessStatus.failed, 
					lastStepResultMessage: msg
				});
			}
		}).catch(error => {
			let userMessages = Errors.messagesForServerError(error);
			var stateData = {
				lastStepStatus: ProcessStatus.failed
			};
			if (userMessages.requestError) {
				let msg = "An Account could not be created: "+userMessages.requestError;
				stateData.lastStepResultMessage = msg;
			} else {
				stateData.lastStepResultMessage = null;
			}
			stateData.lastStepFieldValidationMessages = userMessages.fieldErrors;
			this.setState(stateData);
		});
	}

	verifyAccount(challengeAnswer) {
		let combinedData = Object.assign({}, 
			this.state.challenge,
			challengeAnswer
		);
		delete combinedData.question;
		delete combinedData.contactId;
		let requestData = JSON.stringify(combinedData);
		let request = {
			method: "post",
			url: "signup/verifyAcct",
			data: requestData
		};
		
		this.props.server(request).then((response) => {
			let challenge = response.data;
			this.nextStep({
				challenge: challenge, 
				lastStepStatus: ProcessStatus.succeeded
			});
		}).catch(error => {
			let userMessages = Errors.messagesForServerError(error);
			var stateData = {
				lastStepStatus: ProcessStatus.failed
			};
			if (userMessages.requestError) {
				let msg = userMessages.requestError;
				stateData.lastStepResultMessage = msg;
			} else {
				stateData.lastStepResultMessage = null;
			}
			stateData.lastStepFieldValidationMessages = userMessages.fieldErrors;
			this.setState(stateData);
		});
	}

	changePassword(formData) {
		let changePWData = {
			contactId: this.contactId,
			signature: this.state.challenge.signature,
			chksum: this.state.challenge.chksum,
			loginName: this.userId,
			password: formData.password,
			emailAddr: null
		};
		let requestData = JSON.stringify(changePWData);
		let request = {
			method: "post",
			url: "signup/passwdReset",
			data: requestData
		};
		this.props.server(request).then(() => {
			this.props.setUserIDAction(this.userId);
			this.nextStep({
				challenge: null, 
				lastStepStatus: ProcessStatus.succeeded
			});
		}).catch(error => {
			let userMessages = Errors.messagesForServerError(error);
			var stateData = {
				lastStepStatus: ProcessStatus.failed
			};
			if (userMessages.requestError) {
				let msg = "There was a problem contacting the server: "+userMessages.requestError;
				stateData.lastStepResultMessage = msg;
			} else {
				stateData.lastStepResultMessage = null;
			}
			stateData.lastStepFieldValidationMessages = userMessages.fieldErrors;
			this.setState(stateData);
		});

	}
	
	nextStep(updatedState) {
		let additionalState = updatedState ? updatedState : {};
		let newState = Object.assign({},
			additionalState,
			{
				processStep: ResetPasswordStep.nextAfter(this.state.processStep)
			}
		);
		this.setState(newState);
	}

	getResetUI() {
		let segmentTitles = ["User ID", "Transaction Amount", "New Password"];
		let currentUI;
		switch(this.state.processStep) {
		case ResetPasswordStep.userId:
			currentUI = 
				<React.Fragment>
					<SegmentedProgress 
						segmentTitles={segmentTitles}
						currentSegment={this.state.processStep}
					/>
					<ResetPWUserID
						lastStepStatus={this.state.lastStepStatus}
						lastStepResultMessage={this.state.lastStepResultMessage}
						lookupAccountAction={this.lookupAccount}
					/>
				</React.Fragment>;
			break;
		case ResetPasswordStep.challenge:
			currentUI = 
				<React.Fragment>
					<SegmentedProgress 
						segmentTitles={segmentTitles}
						currentSegment={this.state.processStep}
					/>
					<SignupChallenge
						challengeData={this.state.challenge}
						lastStepStatus={this.state.lastStepStatus}
						lastStepResultMessage={this.state.lastStepResultMessage}
						verifyAccountAction={this.verifyAccount}
					/>
				</React.Fragment>;
			break;
		case ResetPasswordStep.newPassword:
			currentUI = 
				<React.Fragment>
					<SegmentedProgress 
						segmentTitles={segmentTitles}
						currentSegment={this.state.processStep}
					/>
					<ResetPWNewPassword
						companyInfo={this.state.challenge}
						lastStepStatus={this.state.lastStepStatus}
						lastStepResultMessage={this.state.lastStepResultMessage}
						changePasswordAction={this.changePassword}
					/>
				</React.Fragment>;
			break;
		case ResetPasswordStep.success:
			currentUI = 
				<ResetPWSuccess 
					history={this.props.history}
				/>;
			break;
		default: 
			currentUI = <h1>Programming Error: Unknown Reset Password Step {this.state.processStep}</h1>;
		}
		return currentUI;
	}

	render() {
		return (
			<div className="signupPage">
				<h2>Reset Your Password</h2>
				{this.getResetUI()}
			</div>
		);
	}
}

ResetPassword.propTypes = {
	userId: PropTypes.string,
	history: PropTypes.object,
	server: PropTypes.func,
	setUserIDAction: PropTypes.func
};

const ProcessStatus = {
	inProgress: 1,
	succeeded: 10,
	failed: 20
};

const ResetPasswordStep = {
	userId: 1,
	challenge: 2,
	newPassword: 3,
	success: 4,

	nextAfter: function(nextAfter) {
		switch (nextAfter) {
		case ResetPasswordStep.userId:
			return ResetPasswordStep.challenge;
		case ResetPasswordStep.challenge:
			return ResetPasswordStep.newPassword;
		case ResetPasswordStep.newPassword:
			return ResetPasswordStep.success;
		default:
			return ResetPasswordStep.userId;
		}
	}
};


class ResetPWUserID extends Component {
	constructor(props) {
		super(props);

		this.formValidator = new FormValidator(
			null,
			UtilDataValidators.allFieldsRequired
		);

		this.lookupAccount = this.lookupAccount.bind(this);
	}

	lookupAccount(formData) {
		this.props.lookupAccountAction(formData);
	}

	render() {
		let errMsg = this.props.lastStepStatus === ProcessStatus.failed ?
			this.props.lastStepResultMessage :
			null;
		return (
			<div className="createAccountForm">
				<h3>Step 1: Your User ID</h3>
				<p>Please verify you User ID.</p>
				<p>Can&rsquo;t remember your User ID?  <Link to="/contact">Contact Us</Link>.</p>
				<ValidatedForm
					onSubmit={this.lookupAccount} 
					dataValidationMessage = {errMsg}
					formValidator={this.formValidator}
					submitButtonLabel="Lookup Account"
				>
					<InputAdapter 						
						fieldName="username" 
						componentProps= {{
							type: "text",
							label: "User ID",
							required: true
						}}
					/>
				</ValidatedForm>
			</div>
		);
	}
}

ResetPWUserID.propTypes = {
	lastStepStatus: PropTypes.number,
	lastStepResultMessage: PropTypes.string,
	lookupAccountAction: PropTypes.func
};

class ResetPWNewPassword extends Component {
	constructor(props) {
		super(props);

		this.formValidator = new FormValidator(
			{confirmedPassword: ConfirmPasswordValidator},
			UtilDataValidators.allFieldsRequired
		);

		this.changePassword = this.changePassword.bind(this);
	}

	changePassword(formData) {
		let newPWData = Object.assign({}, formData);
		delete newPWData.confirmPassword;
		this.props.changePasswordAction(newPWData);
	}

	render() {
		let errMsg = this.props.lastStepStatus === ProcessStatus.failed ?
			this.props.lastStepResultMessage :
			null;
		return (
			<div className="createAccountForm">
				<h3>Welcome {this.props.companyInfo.companyName}</h3>
				<p>
				Validation of your account was successful. 
				</p>
				<h3>Step 3: Create a New Password</h3>
				<ValidatedForm
					onSubmit={this.props.changePasswordAction}
					dataValidationMessage={errMsg}
					validationMessages={this.props.lastStepFieldValidationMessages}
					formValidator={this.formValidator}
					submitButtonLabel="Set Password"
				>
					<InputAdapter
						fieldName="password"
						componentProps={{
							type: "password",
							label: "Choose a password",
							required: true
						}}
					/>
					<InputAdapter
						fieldName="confirmedPassword"
						componentProps={{
							type: "password",
							label: "Confirm Password",
							required: true
						}}
					/>
				</ValidatedForm>
			</div>
		);
	}

}

ResetPWNewPassword.propTypes = {
	lastStepStatus: PropTypes.number,
	lastStepResultMessage: PropTypes.string,
	lastStepFieldValidationMessages: PropTypes.array,
	companyInfo: PropTypes.object,
	changePasswordAction: PropTypes.func
};

function ResetPWSuccess(props) {
	return (
		<div className="createAccountForm">
			<h2>Your password has been reset successfully.</h2>
			<p>You may now sign in to your account.</p>
			<Button 
				raised primary 
				label="Sign In" 
				className="signupNextButton" 
				onClick={() => {props.history.replace("/");}}
			/>	
		</div>
	);
}

ResetPWSuccess.propTypes = {
	history: PropTypes.object
};

export default ResetPassword;


// WEBPACK FOOTER //
// ./src/components/ResetPassword.js